module.exports = __webpack_public_path__ + "static/media/pills.dd20e0b7.svg";